import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent, IconName } from '@sirius/common';

@Component({
    selector: 'ur-highlight-item',
    template: `
        @if (icon) {
            <sirius-icon
                class="highlight-item__icon"
                [name]="icon"
                aria-hidden="true"
                data-cy="highlight-item-icon"></sirius-icon>
        }
        <div
            class="highlight-item-content sir-text-style-paragraph-m-default"
            data-cy="highlight-item-content">
            @if (title) {
                <h3
                    class="highlight-item__title sir-text-style-paragraph-m-bold"
                    data-cy="highlight-item-title">
                    {{ title }}
                </h3>
            }
            <ng-content></ng-content>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrl: './highlight-item.component.scss',
    host: {
        '[class.has-icon]': 'icon',
        '[class.has-title]': 'title',
        '[attr.data-cy]': '"highlight-item"',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IconComponent]
})
export class HighlightItemComponent {
    @Input() icon?: IconName;
    @Input() title?: string;
}
